export default "__VITE_ASSET__DBGaF$6k__"